import { isString } from "lodash";

/**
 * Determine if a value is a non-empty string
 */
export const isNonEmptyString = (value: unknown): value is string => {
  return isString(value) && value.trim().length > 0;
};
